import { i18n, I18n } from "../i18n/i18n";

const getPreferredLocaleI18n = (locale: string): I18n => i18n[locale];

const getBrowserLocaleI18n = (): I18n => {
  const language = window.navigator.language;
  if (language) {
    const locale = language.split("-")[0];
    return i18n[locale];
  }
};

const getFallbackLocaleI18n = (): I18n => i18n.en;

// TODO This is not used in code, locale should be passed from backend or detected locally
export const getI18n = (preferredLocale?: string): I18n => {
  return getPreferredLocaleI18n(preferredLocale) || getBrowserLocaleI18n() || getFallbackLocaleI18n();
};
